import { c as _c } from "react/compiler-runtime";
import { Circle, ProgressCircle } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { CheckIcon } from '@src/components/sco/icons';
import React from 'react';
type ContentTrackDotIndicator = {
  isActive?: boolean;
  contentTrackSectionId?: string;
  contentTrackStepId?: string;
};
export const ContentTrackDotIndicator = props => {
  const $ = _c(13);
  const trackContext = useContentTrackContext();
  let t0;
  if ($[0] !== props.contentTrackSectionId || $[1] !== props.contentTrackStepId || $[2] !== trackContext) {
    t0 = trackContext.getProgress(props.contentTrackSectionId, props.contentTrackStepId);
    $[0] = props.contentTrackSectionId;
    $[1] = props.contentTrackStepId;
    $[2] = trackContext;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const trackProgress = t0;
  const isCompleted = trackProgress?.completionAsPercent >= 97;
  const completionAsPercent = isCompleted ? 100 : trackProgress?.completionAsPercent;
  if (isCompleted) {
    const t1 = isCompleted ? "statusSuccess" : "primaryAlpha.500";
    const t2 = props.isActive ? "transparent" : "primaryAlpha.500";
    let t3;
    if ($[4] !== isCompleted) {
      t3 = isCompleted && <CheckIcon color="black" opacity={1} width="0.6em" />;
      $[4] = isCompleted;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
      t4 = <Circle bgColor={t1} borderColor={t2} size="md">{t3}</Circle>;
      $[6] = t1;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProgressCircle.Circle><ProgressCircle.Track stroke="bg.darkest" /><ProgressCircle.Range stroke="colorPalette.500" /></ProgressCircle.Circle>;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== completionAsPercent) {
    t2 = <ProgressCircle.Root size="sm" value={completionAsPercent}>{t1}</ProgressCircle.Root>;
    $[11] = completionAsPercent;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};